import { useTranslation } from 'react-i18next';
import { STATUS_BADGE } from '@/components/ui/pageChrome';
import { RECEIPT_TONE_CLASS, referralReceiptBadge } from '@/lib/referral/referralReceiptDisplay';
import { cn } from '@/utils/cn';

/** Receipt status of a sent referral, as the clinician sees it. */
export function ReferralReceiptBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const badge = referralReceiptBadge(status);
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5',
        STATUS_BADGE,
        RECEIPT_TONE_CLASS[badge.tone],
      )}
    >
      {t(`patients.hospital_referral.${badge.key}`, badge.fallback)}
    </span>
  );
}
